export default {
  label: {
    SENT: 'Sent',
    RECEIVED: 'Received',
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    1: 'No issue',
    2: 'To be issued',
    3: 'Not yet read',
    4: 'Issue error',
    5: 'Read',
    6: 'Accepted',
    7: 'Rejected',
    8: 'External collection',
    9: 'Issued collection',
    10: 'External payment',
    11: 'Issued payment',
    12: 'Charged',
    13: 'Paid',
    14: 'Corrected',
    15: 'Notified',
    16: 'Automatically downloaded',
    17: 'Sent to external platform',
    18: 'Accepted by external platform',
    19: 'Rejected by external platform',
    20: 'Pro forma sent',
    21: 'Pro forma readed',
    22: 'Pro forma accepted',
    23: 'Pro forma sent',
    29: 'Pro forma rejected',
    30: 'In custody',
    31: 'Registred',
    32: 'In process of authorisation',
    33: 'In progress of pay',
    34: 'Incidence management',
    35: 'Registred in the RCF',
    36: 'Posted',
    37: 'Payment returned',
    38: 'Cancelled',
    39: 'Cancel requested',
    40: 'Cancel accepted',
    41: 'Cancel rejected'
  }
}
